/**
 * AlmadarPostSoftwareThatSharesENAlmadarPostSoftwareThatSharesENPage
 *
 * Page component for AlmadarPostSoftwareThatSharesENAlmadarPostSoftwareThatSharesENPage
 * Path: /blog/software-that-shares
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostSoftwareThatSharesENPostPageView as __AlmadarPostSoftwareThatSharesENPostPageView } from '@/components/traits/AlmadarPostSoftwareThatSharesENPostPageView';
import { AlmadarPostSoftwareThatSharesENPostAnalyticsView as __AlmadarPostSoftwareThatSharesENPostAnalyticsView } from '@/components/traits/AlmadarPostSoftwareThatSharesENPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostSoftwareThatSharesENAlmadarPostSoftwareThatSharesENPageProps {
  // Add any page-level props here
}

export function AlmadarPostSoftwareThatSharesENAlmadarPostSoftwareThatSharesENPage(_props: AlmadarPostSoftwareThatSharesENAlmadarPostSoftwareThatSharesENPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostSoftwareThatSharesENPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostSoftwareThatSharesENPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostSoftwareThatSharesENAlmadarPostSoftwareThatSharesENPage;
